import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="scrolltotop"
export default class extends Controller {
  scroll() {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }
}
